module.exports = "<scxml initial=\"modal-closed\">\n  <state id=\"modal-closed\" initial=\"gallery\">\n    <state id=\"gallery\">\n      <transition target=\"carousel\" event=\"go-to-carousel\"/>\n    </state>\n    <state id=\"carousel\">\n      <transition target=\"gallery\" event=\"go-to-gallery\"/>\n    </state>\n    <history id=\"reentry\"/>\n    <transition event=\"open-modal\" target=\"modal-open\"/>\n  </state>\n  <state id=\"modal-open\">\n    <transition event=\"close-modal\" target=\"reentry\"/>\n  </state>\n</scxml>\n"


//////////////////
// WEBPACK FOOTER
// ./src/examples/history-example/history.scxml
// module id = 885
// module chunks = 71927732402021